var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"simple-vertical-scroll",class:[_setup.isIos ? 'ios-vertical' : 'no-ios-vertical']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }